import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingService } from 'src/app/outing/outing.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { OutingDetailsDto } from '../dtos/outing-details.dto';
import { OutingIterationQueryFilter } from '../models/outing-iteration-query-filter';
import { MatDialog } from '@angular/material/dialog';
import { OutingEditModalComponent } from '../outing-edit-modal/outing-edit-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-outing-details',
    templateUrl: './outing-details.component.html',
    styleUrls: ['./outing-details.component.scss'],
    standalone: false
})
export class OutingDetailsComponent extends BaseComponent implements OnInit {
  public outingDetailsDto: OutingDetailsDto = new OutingDetailsDto();
  public id: string;
  public iterationsDataSource = new MatTableDataSource<any>(); 
  public permissionsDataSource = new MatTableDataSource<any>(); 
  @ViewChild(MatPaginator) iterationsPaginator: MatPaginator;
  @ViewChild(MatPaginator) permissionsPaginator: MatPaginator;
  public iterationsDisplayedColumns = ['courseName', 'startDate', 'cost', 'fullAddress', 'edit'];
  public permissionsDisplayedColumns = ['name', 'firstName', 'lastName'];
  constructor(public sessionService: SessionService,
    private outingService: OutingService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    stringHelpers: StringHelpers) { 
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.iterationsDataSource.paginator = this.iterationsPaginator;
    this.permissionsDataSource.paginator = this.permissionsPaginator;
    this.getOutingDetails();
  }

  getOutingDetails(){
    this.isLoading = true;
    this.outingService.getOutingDetails(this.id).subscribe((results: any) => {
      this.outingDetailsDto = results;
      this.iterationsDataSource.data = results.iterations;
      this.permissionsDataSource.data = results.permissions;
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });
  }

  editOuting() {
    const dialogRef = this.dialog.open(OutingEditModalComponent, {
      width: '40vw'
    });

    dialogRef.componentInstance.outing = {id: this.outingDetailsDto.details.id, name: this.outingDetailsDto.details.name}

    dialogRef.afterClosed().subscribe(() => {
      this.getOutingDetails();
    });
  }

}
